
import React, { useState } from 'react'
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap'

import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'

import InputFormControl from '@/Components/InputFormControl/InputFormControl'
import Swal from 'sweetalert2'

const TeamSettings = () => {
  const { t } = useTranslation()

  const { teamSelected, updateTeam, deleteTeam } = useTeams()

  const [ name, setName ] = useState(teamSelected.name)
  const [ saving, setSaving ] = useState(false)

  const handleSaveChanges = async () => {

    setSaving(true)
    await updateTeam(name)

    setSaving(false)
  }

  const handleDeleteTeam = async () => {

    const answer = await Swal.fire({
      title: t('TEAMS:RemoveTeamAlertTitle'),
      text: t('TEAMS:RemoveTeamAlertContent'),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t('TEAMS:RemoveTeamAlertCancelButton'),
      confirmButtonText: t('TEAMS:RemoveTeamAlertConfirmButton'),
      width: "500px"
    })

    if (answer.isConfirmed) {
      // dispatch(TeamsActions.deleteRowAction(team, project_id)).then(() => {
      //   loadTeams()
      //   setShowTeamEditor(false)
      // })

      await deleteTeam()
    }
  }

  return (
    <div className='settings-section'>
      <h5>
        Información del equipo
      </h5>
      <FormGroup as={Row}>
        <FormLabel as={Col} sm={12}>Nombre del equipo</FormLabel>
        <Col sm={6}>
          <div className='mb-1'>
            <InputFormControl
              value={name}
              onChange={setName}
            />
          </div>
          <p className='mb-2'>
            Este nombre será visible para todos los miembros del equipo
          </p>
        </Col>
      </FormGroup>
      <div>
        <button className="btn btn-update-team"
          onClick={handleSaveChanges}
          disabled={saving}
        >
          <span className="icon-guardar"></span>
          Guardar cambios
        </button>
      </div>
      <div className="danger-zone">
        <h5>
          <i className="fas fa-fw fa-exclamation-circle"></i> {' '}
          Zona Peligrosa
        </h5>
        <p className='ml-4'>
          Las acciones en esta sección son irreversibles. Por favor, procede con precaución.
        </p>
        <hr className='mt-2 mb-4' />
        <div className='danger-row'>
          <div className="danger-texts">
            <label htmlFor="">
              Eliminar este equipo
            </label>
            <p className='mb-1'>
              Una vez eliminado, no hay vuelta atrás.
            </p>
          </div>
          <div className="danger-actions">
            <button className="btn btn-danger"
              onClick={handleDeleteTeam}
            >
              <span className="icon-eliminar"></span>
              Eliminar equipo
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamSettings
